export const generateIdempotencyKey = (): string => crypto.randomUUID();
